import type { SensitiveAttributeField } from "@/lib/pharmacyFirst/types";

// Sensitive fields may arrive wrapped with their processing basis, or as a bare
// value. These unwrap for display/editing without caring which.

export function isSensitiveAttributeField(
  value: unknown,
): value is SensitiveAttributeField<unknown> {
  return (
    typeof value === "object" &&
    value !== null &&
    "value" in value &&
    "consentBasis" in value &&
    "purposeOfProcessing" in value &&
    "consentObtainedAt" in value
  );
}

export function getSensitiveAttributeDisplayValue(value: unknown): unknown {
  return isSensitiveAttributeField(value) ? value.value : value;
}
